import { Component, inject, signal } from '@angular/core';
import { MaterialModule } from '../../modules/material/material.module';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faAnglesDown, faUser, faEnvelope, faRotate, faAddressCard, faUserPlus, faPhone, faCalendarDays, faCartShopping, faTrashCan, faTriangleExclamation, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Router, ActivatedRoute } from '@angular/router';
import { MemberService } from '../../services/member.service';
import { MatDialog } from '@angular/material/dialog';
import { PopUpDialogComponent } from '../pop-up-dialog/pop-up-dialog.component';
import { DividerModule } from 'primeng/divider';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'app-register-page',
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DividerModule,
    QRCodeComponent
  ],
  templateUrl: './register-page.component.html',
  styleUrl: './register-page.component.scss'
})
export class RegisterPageComponent {

  private memberService = inject(MemberService);

  preRegisterdTvxPlusId: string | null = null;
  registerLoading: boolean = false;
  registrationSuccess: boolean = false;

  // tvxIdControl = new FormControl('', [
  //   Validators.required,
  //   Validators.minLength(1),
  //   Validators.maxLength(10),
  // ]);
   firstnameControl = new FormControl('', [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(80),
  ]);
  lastnameControl = new FormControl('', [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(80),
  ]);
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  phoneControl = new FormControl('', [Validators.required, ValidatePhone]);
  tcControl = new FormControl(false, [Validators.requiredTrue]);

  tvxPlusId = signal('');

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public library: FaIconLibrary
  ) {
    library.addIcons(
      // faAnglesDown,
      faUser,
      // faRotate,
      faAddressCard,
      faUserPlus,
      faEnvelope,
      faPhone,
      // faCalendarDays,
      // faCartShopping,
      // faTrashCan,
      // faTriangleExclamation,
      faCheckCircle
    );
  }

  ngOnInit() {
    console.log("All snapshot query params", this.route.snapshot.queryParamMap);
    this.preRegisterdTvxPlusId = this.route.snapshot.queryParamMap.get('id');
    console.log("Pre-registerd Tvx Plus Id", this.preRegisterdTvxPlusId);
  }


  register() {
    
    this.registerLoading = true;

    if (this.preRegisterdTvxPlusId != null) {
      this.memberService.complteteMemberRegistration({
        tvxPlusId: this.preRegisterdTvxPlusId,
        firstname: this.firstnameControl.value!,
        lastname: this.lastnameControl.value!,
        email: this.emailControl.value!,
        phoneNumber: this.phoneControl.value!,
      }).subscribe(
        (response) => {
          console.log('Registration successful:', response);
          this.tvxPlusId.set(response.tvxPlusId);
          this.registerLoading = false;
          this.registrationSuccess = true;
        },
        (error) => {
          console.error('Registration failed:', error);
          this.registerLoading = false;
          this.registrationSuccess = false;
          this.openDialog(
            'Registration Failed',
            error.error?.message || 'Cannot find your transaction.',
            'OK',
            '0ms',
            '0ms'
          );
        }
      )
    }
    else{
      this.memberService.registerMember({
        firstname: this.firstnameControl.value!,
        lastname: this.lastnameControl.value!,
        email: this.emailControl.value!,
        phoneNumber: this.phoneControl.value!,
      }).subscribe(
        (response) => {
          console.log('Registration successful:', response);
          this.tvxPlusId.set(response.tvxPlusId);
          this.registerLoading = false;
          this.registrationSuccess = true;
        },
        (error) => {
          console.error('Registration failed:', error);
          this.registerLoading = false;
          this.registrationSuccess = false;
          this.openDialog(
            'Registration Failed',
            'Cannot find your transaction.',
            'OK',
            '0ms',
            '0ms'
          );
        }
      )
    }
  }

  async openDialog(
    title: string,
    content: string,
    btnLabel: string,
    enterAnimationDuration: string,
    exitAnimationDuration: string
  ): Promise<void> {
    let dialogRef = this.dialog.open(PopUpDialogComponent, {
      data: {
        title: title,
        content: content,
        btnLabel: btnLabel,
      },
      width: '300px',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed');
      window.location.reload();
    });
  }

}

function ValidatePhone(control: AbstractControl): {[key: string]: any} | null  {
  if (control.value) {
    console.log('isValidPhoneNumber', isValidPhoneNumber('+44'+control.value, 'GB'));
    if(!isValidPhoneNumber('+44' + control.value, 'GB') ){
      return {invalidPhoneNumber: true};
    }
  }
  return null;
}
